import { render, staticRenderFns } from "./MoleculeEditionBillingAcademyProyectsDetails.vue?vue&type=template&id=1bb218a0"
import script from "./MoleculeEditionBillingAcademyProyectsDetails.vue?vue&type=script&lang=js"
export * from "./MoleculeEditionBillingAcademyProyectsDetails.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports